module.exports = __webpack_public_path__ + "static/media/apper.5bf605f8.svg";